export class TopupRequestModel {
  page?: number;
  limit?: number;
  name?: string;
  code?: string;
  status?: number;
  carrier?: string;
  category?: string;
  pagination?: boolean | number;
  order?: string;
  service?: string;
  keywords?: string;
  categoriesForQuery?: string;
  fromPrice?: number;
  toPrice?: number;
  priceRange?: string;
  created?: Array<Record<string, unknown>>;
  fromDate?: string;
  toDate?: string;
}
